import {
  updateRangeFacet,
  setRangeValues,
  undoRangeValues,
  clearRangeFacet,
} from "../../store/actionCreators";
import { isLargeMediumViewPort } from "../../ui/helpers/viewportHelper";
import applyFacets from "../../filters/thunks/apply";
import {
  analyticsRefinementsSelect,
  analyticsAddPendingRefinementSelect,
} from "../../../../analytics/actions";

export { updateRangeFacet, clearRangeFacet };

export const setNextPriceRangeToCurrent = setRangeValues;

export const undoPriceRange = undoRangeValues;

export function changeRangeFacet(facetId, value) {
  return (dispatch) => {
    dispatch(updateRangeFacet(facetId, value));
  };
}

export function applyRangeFacet(facet) {
  return (dispatch, getState) => {
    const state = getState();
    if (isLargeMediumViewPort(state)) {
      dispatch(applyFacets());
      dispatch(analyticsAddPendingRefinementSelect({ facet }));
    } else {
      dispatch(analyticsRefinementsSelect({ facet }));
    }
  };
}
